module.exports = __webpack_public_path__ + "static/media/logo_border_text_white.26356077.png";